import { FormattedEvent } from '@eventbrite/event-renderer';

interface LatLngs {
    lat?: number;
    lng?: number;
}

interface LatLngBounds {
    ne: { lat: number; lng: number };
    sw: { lat: number; lng: number };
}

export const calculateAverageCenter = (
    clusters: { geometry: { coordinates: number[] } }[],
    defaultCenter?: { lat: number; lng: number },
) => {
    let latSum = 0;

    let lonSum = 0;

    clusters.forEach(({ geometry }) => {
        /* Rough approximation of center point by averaging incoming
        events lat lon values */
        const lng = geometry.coordinates[0].toString();
        const lat = geometry.coordinates[1].toString();

        latSum += parseFloat(lat);
        lonSum += parseFloat(lng);
    });

    let center = {
        lat: latSum / clusters.length,
        lng: lonSum / clusters.length,
    };

    if ((!latSum || !lonSum) && defaultCenter) {
        center = defaultCenter;
    }

    return center;
};

export const convertEventsToGeoJSON = (events: FormattedEvent[]) =>
    // map events to objects that meet GeoJSON spec
    events.map((event) => ({
        type: 'Feature',
        geometry: {
            type: 'Point',
            coordinates: [
                event.venue?.address.longitude,
                event.venue?.address.latitude,
            ],
        },
        properties: {
            name: event.name,
            id: event.id,
            startDate: event.startDate,
            startTime: event.startTime,
            venueName: event.venue?.name,
            venueAddress: event.venue?.address.localizedAreaDisplay,
            minPrice: event.minPrice,
            url: event.url,
            imageUrl: event.imageUrl,
            isFree: event.isFree,
            ticketsBy: event.ticketsBy,
            savedByYou: event.savedByYou,
            repeatingInstanceCount: event.repeatingInstanceCount,
        },
    }));

export const isSingleCluster = (clusters: string | any[]) =>
    clusters.length === 1 ? clusters[0].properties.cluster_id : null;

export const getLatLngsFromEvents = (events: FormattedEvent[]): LatLngs[] =>
    events.map(({ venue }) => ({
        lat:
            typeof venue?.address.latitude === 'string'
                ? parseFloat(venue?.address.latitude)
                : undefined,
        lng:
            typeof venue?.address.longitude === 'string'
                ? parseFloat(venue?.address.longitude)
                : undefined,
    }));

const MAX_NUMBER = 100000000;
const MIN_NUMBER = -10000000;
export function getBoundsFromEventLatLngs(latLngs: LatLngs[]): LatLngBounds {
    const bounds = latLngs.reduce(
        (memo, eventPos) => {
            if (
                typeof eventPos.lat === 'number' &&
                typeof eventPos.lng === 'number'
            ) {
                memo.ne.lat = Math.max(memo.ne.lat, eventPos.lat);
                memo.sw.lat = Math.min(memo.sw.lat, eventPos.lat);
                memo.ne.lng = Math.max(memo.ne.lng, eventPos.lng);
                memo.sw.lng = Math.min(memo.sw.lng, eventPos.lng);
            }

            return memo;
        },
        {
            ne: { lat: 0, lng: MIN_NUMBER },
            sw: { lat: MAX_NUMBER, lng: 0 },
        },
    );

    return bounds;
}
